module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledCaiman_m_normal.d89decfa.png";